import "core-js/modules/es.array.reduce.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b57964f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-name"
};
const _hoisted_2 = {
  class: "menu-manager-container"
};
const _hoisted_3 = {
  class: "card left-card-content"
};
const _hoisted_4 = {
  class: "col1"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "col2"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "col3"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "publish-btn"
};
const _hoisted_11 = {
  key: 0,
  class: "card right-card-content"
};
const _hoisted_12 = {
  class: "name"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "仅支持中英文和数字,子菜单名称字数不超过8个汉字或16个字母,一级菜单名称字数不超过4个汉字或8个字母", -1));
const _hoisted_14 = {
  class: "label"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "15px"
  }
}, "子菜单内容", -1));
const _hoisted_16 = {
  class: "panel"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "article_id:", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "图文消息链接是点击菜单进入图文消息网页,图文消息是公众号弹出图文消息", -1));
const _hoisted_21 = {
  class: "panel"
};
const _hoisted_22 = {
  class: "form",
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px",
    "width": "70px"
  }
}, "关键字", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "52px"
  }
}, "请输入自动回复已设置的自动回复关键字", -1));
const _hoisted_25 = {
  class: "panel"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "media_id:", -1));
const _hoisted_29 = {
  key: 1,
  class: "webpage"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "订阅者点击该子菜单会跳到以下链接", -1));
const _hoisted_31 = {
  class: "form"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px",
    "width": "70px"
  }
}, "页面地址", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "80px",
    "margin-bottom": "10px"
  }
}, "例:http://www.baidu.com", -1));
const _hoisted_34 = {
  key: 2,
  class: "applet"
};
const _hoisted_35 = {
  class: "form"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px",
    "width": "100px"
  }
}, "appId", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "110px",
    "margin-bottom": "10px"
  }
}, "例:wx9ccd0396814c957b", -1));
const _hoisted_38 = {
  class: "form"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px",
    "width": "100px"
  }
}, "小程序首页地址", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "110px",
    "margin-bottom": "10px"
  }
}, "例:pages/home/home", -1));
const _hoisted_41 = {
  class: "form"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px",
    "width": "100px"
  }
}, "备用网页", -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "110px",
    "margin-bottom": "0px"
  }
}, "例:http://www.baidu.com", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "margin-left": "110px"
  }
}, "旧版微信客户端无法支持小程序, 用户点击菜单时将会打开备用网页", -1));
const _hoisted_45 = {
  class: "button"
};
const _hoisted_46 = {
  class: "images-Select-Box"
};
const _hoisted_47 = ["src", "onClick"];
const _hoisted_48 = {
  key: 0,
  class: "example-pagination-block"
};
const _hoisted_49 = {
  class: "dialog-box"
};
const _hoisted_50 = {
  class: "dialog-parcel"
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = {
  class: "news-title"
};
const _hoisted_53 = {
  class: "news-description"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { Plus } from '@element-plus/icons-vue';
import { getAllNewsReplyById, getMaterial } from '@/api/greeting';
import { delMenuItem, getMenuByAccountId, publishMenu, saveMenu } from '@/api/menu';
import urlDialog from '@/components/UrlDialog';
export default {
  __name: 'menu-manage',
  setup(__props) {
    const route = useRoute();
    const {
      accountId,
      path
    } = route.params;
    const originMenuData = ref([]);
    const getMenuData = async () => {
      const res = await getMenuByAccountId(accountId);
      const data = res.reduce((prev, cur, arr) => {
        if (cur.menuRow === 0) {
          prev[`col${cur.menuCol}`] = prev[`col${cur.menuCol}`].filter(item => item.menuRow !== cur.menuRow);
        }
        prev[`col${cur.menuCol}`] = [...prev[`col${cur.menuCol}`], cur];
        prev[`col${cur.menuCol}`].sort((b, a) => a.menuRow - b.menuRow);
        return prev;
      }, {
        col1: [{
          menuCol: 1,
          menuRow: 0,
          name: '一级菜单',
          menuType: 5,
          state: 1
        }],
        col2: [{
          menuCol: 2,
          menuRow: 0,
          name: '一级菜单',
          menuType: 5,
          state: 1
        }],
        col3: [{
          menuCol: 3,
          menuRow: 0,
          name: '一级菜单',
          menuType: 5,
          state: 1
        }]
      });
      originMenuData.value = data;
    };
    getMenuData();
    const form = ref({
      subMenuName: ''
    });
    const rules = {
      subMenuName: [{
        required: true,
        message: '子菜单名称不能为空',
        trigger: 'blur'
      }, {
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
        message: '仅支持中英文和数字',
        trigger: 'blur'
      }]
    };
    const appid = ref('');
    const appPath = ref('');
    const url = ref('');
    // 菜单值
    const value = ref('');
    // 发送消息类型
    const activeName = ref('news');

    // 子菜单内容分类
    const menuCategory = ref('sendMeg');

    // watch(menuCategory, () => {
    //   value.value = ''
    //   currentSelectImage.value = {}
    // })

    // 点击切换发送消息类型事件
    const handleClick = e => {
      value.value = '';
      currentSelectImage.value = {};
    };

    // 图片选择显示隐藏
    const imageVisible = ref(false);
    // 已选择图片
    const currentSelectImage = ref({});

    // 获取素材的currentPage
    const currentPage = ref(1);
    const materialList = ref([]);
    const total = ref(0);
    const getMaterialData = async () => {
      const res = await getMaterial(path, 'image', currentPage.value);
      materialList.value = res.item;
      total.value = res.total_count;
      imageVisible.value = true;
    };
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getMaterialData();
    };

    /**
     * 点击当前图片
     */
    const onSelectImageHandler = item => {
      imageVisible.value = false;
      currentSelectImage.value = item;
      value.value = item.media_id;
    };

    // 图文消息弹框显示隐藏
    const isSelectNewsVisible = ref(false);

    // 当前选择的图文
    const currentNews = ref({});

    // 当前页
    const newsCurrentPage = ref(1);

    // 图文自动回复列表
    const newsList = ref([]);

    // 获取图文自动回复列表
    const getNewsData = async () => {
      const res = await getAllNewsReplyById(path, newsCurrentPage.value);
      newsList.value = res.item;
      isSelectNewsVisible.value = true;
    };
    const checkNewsPublishHandler = item => {
      isSelectNewsVisible.value = false;
      currentNews.value = item;
      value.value = item.article_id;
    };

    // 选中的menu
    const curSelectMenuItem = ref({});
    const curRow = ref(0);
    const curCol = ref(0);
    // const menuType = ref(0)
    const menuId = ref('');
    const checkItem = item => {
      curRow.value = item.menuRow;
      curCol.value = item.menuCol;
      menuId.value = item.id;
      curSelectMenuItem.value = item;
      form.value.subMenuName = item.name;
      if (item.menuRow === 0) {
        menuCategory.value = 'l1Menu';
      }
    };
    watch(curSelectMenuItem, val => {
      console.log('val:', val);
      if (val.menuType === 1) {
        menuCategory.value = 'sendMeg';
        activeName.value = 'news';
        value.value = val.value;
        // menuType.value = val.menuType
      } else if (val.menuType === 2) {
        menuCategory.value = 'webPage';
        value.value = val.value;
        // menuType.value = val.menuType
      } else if (val.menuType === 3) {
        menuCategory.value = 'sendMeg';
        activeName.value = 'text';
        value.value = val.value;
        // menuType.value = val.menuType
      } else if (val.menuType === 4) {
        menuCategory.value = 'sendMeg';
        activeName.value = 'news';
        value.value = val.value;
        // menuType.value = val.menuType
      } else if (val.menuType === 5) {
        menuCategory.value = 'l1Menu';
        value.value = '';
        // menuType.value = val.menuType
      } else if (val.menuType === 6) {
        console.log('🚀 ~ file: index.vue:400 ~ watch ~ val:', val);
        menuCategory.value = 'applet';
        appid.value = val.appid;
        appPath.value = val.appPath;
        url.value = val.value;
        // menuType.value = val.menuType
      } else if (val.menuType === 7) {
        menuCategory.value = 'sendMeg';
        activeName.value = 'image';
        value.value = val.value;
        // menuType.value = val.menuType
      } else {
        menuCategory.value = 'sendMeg';
        activeName.value = 'news';
        // menuType.value = 1
      }
    });

    /**
     * 点击添加menuItem
     */
    const addMenuItem = (col, curMenuList) => {
      const menuRow = curMenuList.length;
      originMenuData.value[`col${col}`].unshift({
        menuCol: col,
        menuRow,
        name: menuRow === 0 ? '菜单名称' : '子菜单名称'
      });
      curRow.value = menuRow;
      curCol.value = col;
      form.value.subMenuName = menuRow === 0 ? '菜单名称' : '子菜单名称';
      if (menuRow === 0) {
        menuCategory.value = 'l1Menu';
        // menuType.value = 5
      } else {
        menuCategory.value = 'sendMeg';
        activeName.value = 'news';
        // menuType.value = 1
      }
      menuId.value = '';
    };
    const isLink = ref(false);
    const menuType = computed(() => {
      if (menuCategory.value === 'l1Menu') {
        return 5;
      } else if (menuCategory.value === 'sendMeg' && activeName.value === 'news') {
        if (isLink.value === false) {
          return 1;
        } else {
          return 4;
        }
      } else if (menuCategory.value === 'sendMeg' && activeName.value === 'text') {
        return 3;
      } else if (menuCategory.value === 'sendMeg' && activeName.value === 'image') {
        return 7;
      } else if (menuCategory.value === 'webPage') {
        return 2;
      } else if (menuCategory.value === 'applet') {
        return 6;
      } else {
        return 1;
      }
    });
    watch(menuType, val => {}, {
      immediate: true
    });
    const onSaveHandler = async () => {
      try {
        const res = await saveMenu({
          id: menuId.value,
          accountId: accountId,
          menuCol: curCol.value,
          menuRow: curRow.value,
          name: form.value.subMenuName,
          menuType: menuType.value,
          value: value.value || url.value,
          appid: appid.value,
          appPath: appPath.value
        });
        menuId.value = res.id;
        ElMessage.success('保存成功');
        await getMenuData(accountId);
      } catch (error) {}
    };
    const onPublishHandler = () => {
      let menuArr = [];
      for (const key in originMenuData.value) {
        menuArr = [...menuArr, ...originMenuData.value[key]];
      }
      if (menuArr.every(item => item.state)) {
        ElMessage.error('不能发布空的目录');
        return;
      }
      for (const key in originMenuData.value) {
        if (originMenuData.value[key].length === 1 && originMenuData.value[key][0].menuType === 5 && !originMenuData.value[key][0].state) {
          ElMessage.error('一级菜单如果没有子菜单不能发布');
          return;
        }
      }
      publishMenu(accountId).then(async res => {
        if (res.code > 200) {
          ElMessage.error('发布失败');
          return;
        }
        ElMessage.success('发布成功');
      });
    };

    /**
     * 删除子菜单
     */
    const delSubMenuItem = () => {
      if (!menuId.value) {
        if (originMenuData.value[`col${curCol.value}`].length === 1 && originMenuData.value[`col${curCol.value}`][0].state) {
          ElMessage.warning('无当前菜单');
          return;
        }
        originMenuData.value[`col${curCol.value}`] = originMenuData.value[`col${curCol.value}`].filter(item => {
          return item.menuRow !== curRow.value;
        });
        // console.log(res)
        return;
      }
      if (curRow.value === 0 && originMenuData.value[`col${curCol.value}`].length > 1) {
        ElMessage.warning('不能删除有菜单的子菜单');
        return;
      }
      if (!menuId.value) {
        ElMessage.warning('当前菜单不存在');
        return;
      }
      ElMessageBox.confirm('您是否确定删除?', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        delMenuItem(menuId.value).then(async () => {
          ElMessage.success('删除成功');
          await getMenuData();
        });
      }).catch(res => {});
    };

    // const onUrlClickHandler = (url) => {
    //   value.value = url
    // }

    const isUrlSelectVisible = ref(false);
    const onSelectUrlHandler = () => {
      isUrlSelectVisible.value = true;
    };
    const onSelectUrlConfirmHandler = val => {
      value.value = val.url + path;
      isUrlSelectVisible.value = false;
    };
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$route.params.accountName), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_card, {
        class: "left-card",
        shadow: "never"
      }, {
        default: _withCtx(() => {
          var _originMenuData$value, _originMenuData$value2, _originMenuData$value3, _originMenuData$value5, _originMenuData$value6, _originMenuData$value7, _originMenuData$value8, _originMenuData$value10, _originMenuData$value11, _originMenuData$value12, _originMenuData$value13, _originMenuData$value15;
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [((_originMenuData$value = originMenuData.value) === null || _originMenuData$value === void 0 || (_originMenuData$value = _originMenuData$value.col1) === null || _originMenuData$value === void 0 ? void 0 : _originMenuData$value.length) < 6 && ((_originMenuData$value2 = originMenuData.value) === null || _originMenuData$value2 === void 0 ? void 0 : _originMenuData$value2.col1[((_originMenuData$value3 = originMenuData.value) === null || _originMenuData$value3 === void 0 ? void 0 : _originMenuData$value3.col1.length) - 1].menuType) === 5 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "col-item",
            onClick: _cache[0] || (_cache[0] = $event => {
              var _originMenuData$value4;
              return addMenuItem(1, (_originMenuData$value4 = originMenuData.value) === null || _originMenuData$value4 === void 0 ? void 0 : _originMenuData$value4.col1);
            })
          }, [_createVNode(_component_el_icon, {
            size: 19
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_originMenuData$value5 = originMenuData.value) === null || _originMenuData$value5 === void 0 ? void 0 : _originMenuData$value5.col1, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["col-item", {
                'sub-menu-item': item.menuRow === 0 && item.menuType === 5,
                'select-item': item.menuRow === curRow.value && item.menuCol === curCol.value
              }]),
              onClick: $event => checkItem(item)
            }, _toDisplayString(item.name), 11, _hoisted_5);
          }), 128))]), _createElementVNode("div", _hoisted_6, [((_originMenuData$value6 = originMenuData.value) === null || _originMenuData$value6 === void 0 || (_originMenuData$value6 = _originMenuData$value6.col2) === null || _originMenuData$value6 === void 0 ? void 0 : _originMenuData$value6.length) < 6 && ((_originMenuData$value7 = originMenuData.value) === null || _originMenuData$value7 === void 0 ? void 0 : _originMenuData$value7.col2[((_originMenuData$value8 = originMenuData.value) === null || _originMenuData$value8 === void 0 ? void 0 : _originMenuData$value8.col2.length) - 1].menuType) === 5 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "col-item",
            onClick: _cache[1] || (_cache[1] = $event => {
              var _originMenuData$value9;
              return addMenuItem(2, (_originMenuData$value9 = originMenuData.value) === null || _originMenuData$value9 === void 0 ? void 0 : _originMenuData$value9.col2);
            })
          }, [_createVNode(_component_el_icon, {
            size: 19
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_originMenuData$value10 = originMenuData.value) === null || _originMenuData$value10 === void 0 ? void 0 : _originMenuData$value10.col2, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["col-item", {
                'sub-menu-item': item.menuRow === 0 && item.menuType === 5,
                'select-item': item.menuRow === curRow.value && item.menuCol === curCol.value
              }]),
              onClick: $event => checkItem(item)
            }, _toDisplayString(item.name), 11, _hoisted_7);
          }), 128))]), _createElementVNode("div", _hoisted_8, [((_originMenuData$value11 = originMenuData.value) === null || _originMenuData$value11 === void 0 || (_originMenuData$value11 = _originMenuData$value11.col3) === null || _originMenuData$value11 === void 0 ? void 0 : _originMenuData$value11.length) < 6 && ((_originMenuData$value12 = originMenuData.value) === null || _originMenuData$value12 === void 0 ? void 0 : _originMenuData$value12.col3[((_originMenuData$value13 = originMenuData.value) === null || _originMenuData$value13 === void 0 ? void 0 : _originMenuData$value13.col3.length) - 1].menuType) === 5 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "col-item",
            onClick: _cache[2] || (_cache[2] = $event => {
              var _originMenuData$value14;
              return addMenuItem(3, (_originMenuData$value14 = originMenuData.value) === null || _originMenuData$value14 === void 0 ? void 0 : _originMenuData$value14.col3);
            })
          }, [_createVNode(_component_el_icon, {
            size: 19
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_originMenuData$value15 = originMenuData.value) === null || _originMenuData$value15 === void 0 ? void 0 : _originMenuData$value15.col3, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["col-item", {
                'sub-menu-item': item.menuRow === 0 && item.menuType === 5,
                'select-item': item.menuRow == curRow.value && item.menuCol == curCol.value
              }]),
              onClick: $event => checkItem(item)
            }, _toDisplayString(item.name), 11, _hoisted_9);
          }), 128))])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
            type: "success",
            onClick: onPublishHandler
          }, {
            default: _withCtx(() => [_createTextVNode(" 发布菜单 ")]),
            _: 1
          })])];
        }),
        _: 1
      }), _createVNode(_component_el_card, {
        class: "right-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [curCol.value !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_form, {
          model: form.value,
          rules: rules,
          "hide-required-asterisk": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "子菜单名称",
            prop: "subMenuName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.subMenuName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.subMenuName = $event),
              style: {
                "width": "400px"
              },
              placeholder: "仅支持中英文和数字,子菜单名称字数不超过8个汉字或16个字母,一级菜单名称字数不超过4个汉字或8个字母"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_radio_group, {
          modelValue: menuCategory.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => menuCategory.value = $event),
          onChange: handleClick
        }, {
          default: _withCtx(() => [curRow.value === 0 ? (_openBlock(), _createBlock(_component_el_radio, {
            key: 0,
            label: "l1Menu"
          }, {
            default: _withCtx(() => [_createTextVNode("一级菜单")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_radio, {
            label: "sendMeg"
          }, {
            default: _withCtx(() => [_createTextVNode("发送信息")]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "webPage"
          }, {
            default: _withCtx(() => [_createTextVNode("跳转网页")]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "applet"
          }, {
            default: _withCtx(() => [_createTextVNode("跳转小程序")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), menuCategory.value === 'sendMeg' ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => activeName.value = $event),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "图文消息",
            name: "news"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
              onClick: getNewsData,
              style: {
                "margin-bottom": "10px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(" 选择图文 ")]),
              _: 1
            }), !value.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, "请选择图文素材：")) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createTextVNode(_toDisplayString(value.value), 1)])), _createElementVNode("div", null, [_createTextVNode(" 是否图文消息链接： "), _createVNode(_component_el_switch, {
              modelValue: isLink.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => isLink.value = $event),
              style: {
                "margin-left": "10px"
              }
            }, null, 8, ["modelValue"])]), _hoisted_20])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "文字",
            name: "text"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_el_input, {
              placeholder: "请输入关键字",
              style: {
                "width": "300px"
              },
              modelValue: value.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => value.value = $event)
            }, null, 8, ["modelValue"]), _hoisted_24])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "图片",
            name: "image"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
              onClick: getMaterialData,
              style: {
                "margin-bottom": "10px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(" 选择图片 ")]),
              _: 1
            }), !value.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, "请选择图片素材：")) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createTextVNode(_toDisplayString(value.value), 1)]))])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true), menuCategory.value === 'webPage' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_el_input, {
          placeholder: "请输入页面地址",
          style: {
            "width": "700px"
          },
          modelValue: value.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => value.value = $event)
        }, null, 8, ["modelValue"])]), _hoisted_33, _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSelectUrlHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 选择网页 ")]),
          _: 1
        })])) : _createCommentVNode("", true), menuCategory.value === 'applet' ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_el_input, {
          placeholder: "请输入appid",
          style: {
            "width": "300px"
          },
          modelValue: appid.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => appid.value = $event)
        }, null, 8, ["modelValue"])]), _hoisted_37, _createElementVNode("div", _hoisted_38, [_hoisted_39, _createVNode(_component_el_input, {
          placeholder: "请输入小程序首页地址",
          style: {
            "width": "300px"
          },
          modelValue: appPath.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => appPath.value = $event)
        }, null, 8, ["modelValue"])]), _hoisted_40, _createElementVNode("div", _hoisted_41, [_hoisted_42, _createVNode(_component_el_input, {
          placeholder: "请输入备用网页地址",
          style: {
            "width": "300px"
          },
          modelValue: url.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => url.value = $event)
        }, null, 8, ["modelValue"])]), _hoisted_43, _hoisted_44])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_45, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: onSaveHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存菜单 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: delSubMenuItem
        }, {
          default: _withCtx(() => [_createTextVNode(" 删除菜单 ")]),
          _: 1
        })])])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        title: "选择图片",
        modelValue: imageVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => imageVisible.value = $event),
        onClosed: _cache[13] || (_cache[13] = $event => imageVisible.value = false),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [materialList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(materialList.value, item => {
          return _openBlock(), _createElementBlock("img", {
            key: item.media_id,
            class: "select-image",
            src: item.url,
            alt: "",
            onClick: $event => onSelectImageHandler(item)
          }, null, 8, _hoisted_47);
        }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(" 暂无图片 ")], 64))]), materialList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          total: total.value,
          currentPage: currentPage.value,
          "page-size": 20,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["total", "currentPage"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "选择图文",
        modelValue: isSelectNewsVisible.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => isSelectNewsVisible.value = $event),
        onClosed: _cache[15] || (_cache[15] = $event => isSelectNewsVisible.value = false),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [newsList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(newsList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "news-item",
            onClick: $event => checkNewsPublishHandler(item)
          }, [_createVNode(_component_el_image, {
            src: item.content.news_item[0].thumb_url,
            class: "img"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_52, _toDisplayString(item.content.news_item[0].title), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(item.content.news_item[0].digest), 1)], 8, _hoisted_51);
        }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(" 暂无图文 ")], 64))])])]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_unref(urlDialog), {
        modelValue: isUrlSelectVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => isUrlSelectVisible.value = $event),
        onConfirm: onSelectUrlConfirmHandler
      }, null, 8, ["modelValue"])]);
    };
  }
};